import { type RatingScale, type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { getAnswerDefaultData } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyProviders/defaultAnswerProvider";
import { SurveyQuestionType, SurveyAnswerType } from "features/Library/Surveys/types/models";
import { v4 } from "uuid";

const defaultQuestionData = ((): { [key in SurveyQuestionType]: () => SurveyQuestion<any> } => {
  const getMultipleChoiceTextQuestion = (): SurveyQuestion<string> => ({
    questionType: SurveyQuestionType.MultipleChoiceTextQuestion,
    question: "",
    isRequired: false,
    isBranching: false,
    questionOrder: undefined,
    answers: [getAnswerDefaultData(SurveyAnswerType.Text), getAnswerDefaultData(SurveyAnswerType.Text)],
    id: v4(),
  });

  const getSingleChoiceTextQuestion = (): SurveyQuestion<string> => ({
    questionType: SurveyQuestionType.SingleChoiceTextQuestion,
    question: "",
    isRequired: false,
    isBranching: false,
    questionOrder: undefined,
    answers: [getAnswerDefaultData(SurveyAnswerType.Text), getAnswerDefaultData(SurveyAnswerType.Text)],
    id: v4(),
  });

  const getFreeTextQuestion = (): SurveyQuestion<string> => ({
    questionType: SurveyQuestionType.FreeText,
    question: "",
    isRequired: false,
    isBranching: false,
    questionOrder: undefined,
    answers: [],
    id: v4(),
  });

  const getRatingScaleQuestion = (): SurveyQuestion<RatingScale> => ({
    questionType: SurveyQuestionType.RatingScale,
    question: {
      maxRateLabel: "",
      minRateLabel: "",
      text: "",
    },
    isRequired: false,
    isBranching: false,
    questionOrder: undefined,
    answers: [],
    id: v4(),
  });

  return {
    [SurveyQuestionType.MultipleChoiceTextQuestion]: getMultipleChoiceTextQuestion,
    [SurveyQuestionType.SingleChoiceTextQuestion]: getSingleChoiceTextQuestion,
    [SurveyQuestionType.FreeText]: getFreeTextQuestion,
    [SurveyQuestionType.RatingScale]: getRatingScaleQuestion,
  };
})();

export const getQuestionDefaultData = (questionType?: SurveyQuestionType): SurveyQuestion<any> =>
  defaultQuestionData[questionType ?? SurveyQuestionType.MultipleChoiceTextQuestion]();
